<div class="m-container min-vh-100">
  <p-toast [breakpoints]="toastBreakpoints" />
  @if (loadingService.isLoading()) {
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" class="loading-progressbar"/>
  }
  <router-outlet />
</div>
